import React from "react";
import styles from "./ContentCountList.module.scss";
import { IconEsportsPersonSVG } from "../../assets/img/iconEsportsPersonSVG";
import { IconTeamOwnerSVG } from "../../assets/img/IconTeamOwnerSVG";
import { EventSVG } from "../../common/nav/svg/EventSVG";
import { ProjectSVG } from "../../common/nav/svg/ProjectSVG";
import { TopicsSVG } from "../../common/nav/svg/TopicsSVG";

type Props = {
  profileCount: number;
  teamCount: number;
  projectCount: number;
  eventCount: number;
  topicsCount: number;
};
const ContentCountList: React.FC<Props> = ({
  profileCount,
  teamCount,
  projectCount,
  eventCount,
  topicsCount,
}) => {
  return (
    <ul className={styles["c-count-list"]}>
      <li className={styles["c-count-list__item"]}>
        <div className={styles["c-count-list__item__icon"]}>
          <IconEsportsPersonSVG width={40} height={40} />
        </div>
        <span className={styles["c-count-list__item__title"]}>
          プロフィール
        </span>
        <span className={styles["c-count-list__item__count"]}>
          {profileCount > 0 ? profileCount : "--"}
        </span>
      </li>
      <li className={styles["c-count-list__item"]}>
        <div className={styles["c-count-list__item__icon"]}>
          <IconTeamOwnerSVG width={40} height={40} />
        </div>
        <span className={styles["c-count-list__item__title"]}>チーム</span>
        <span className={styles["c-count-list__item__count"]}>
          {teamCount > 0 ? teamCount : "--"}
        </span>
      </li>
      <li className={styles["c-count-list__item"]}>
        <div className={styles["c-count-list__item__icon"]}>
          <ProjectSVG width={40} height={40} />
        </div>
        <span className={styles["c-count-list__item__title"]}>
          プロジェクト
        </span>
        <span className={styles["c-count-list__item__count"]}>
          {projectCount > 0 ? projectCount : "--"}
        </span>
      </li>
      <li className={styles["c-count-list__item"]}>
        <div className={styles["c-count-list__item__icon"]}>
          <EventSVG width={40} height={40} />
        </div>
        <span className={styles["c-count-list__item__title"]}>イベント</span>
        <span className={styles["c-count-list__item__count"]}>
          {eventCount > 0 ? eventCount : "--"}
        </span>
      </li>
      <li className={styles["c-count-list__item"]}>
        <div className={styles["c-count-list__item__icon"]}>
          <TopicsSVG width={40} height={40} />
        </div>
        <span className={styles["c-count-list__item__title"]}>トピックス</span>
        <span className={styles["c-count-list__item__count"]}>
          {topicsCount > 0 ? topicsCount : "--"}
        </span>
      </li>
    </ul>
  );
};

export default ContentCountList;
